import { AnimatePresence, motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import styled from 'styled-components'

import Modal, { fullAnimate } from '@/components/Modal'
import { deviceInfoStore, useRecoilState, useRecoilValue } from '@/store'

import { stepAnimate } from '..'
import cameraChose1Img from '../images/cameraChose1.png'

const { devicesDataState, fromPageState } = deviceInfoStore

interface IProps {
  rtcEngine: any
  next: (stepActive: number, status?: boolean) => void
}

export default ({ rtcEngine, next }: IProps) => {
  const devicesData = useRecoilValue(devicesDataState)
  const [fromPage, setFromPage] = useRecoilState(fromPageState)
  const [isBtn, setisBtn] = useState<boolean>(true)
  const [noCameraTip, setnoCameraTip] = useState<boolean>(false)
  const [select, setSelect] = useState<string[]>([])

  useEffect(() => {
    if (devicesData.videoDevices?.length === 0) {
      setnoCameraTip(true)
    }
  }, [])

  useEffect(() => {
    setSelect([])
    if (devicesData.videoDevices?.length > 0) {
      try {
        if (devicesData.videoDevices?.length === 1) {
          setSelect([devicesData.videoDevices[0].label])
        }
        // 播放镜头视频，有几个就播放几个
        rtcEngine.playVideoTracks()
      } catch (err) {
        console.error(err)
      }
    }
  }, [devicesData.videoDevices])

  const handleAsk = () => {
    setisBtn((v) => !v)
  }

  const handleNext = (status: boolean) => {
    localStorage.masterCamera = select[0] || ''
    localStorage.viceCamera = select[1] || ''
    setFromPage({
      ...fromPage,
      masterCamera: localStorage.masterCamera,
      viceCamera: localStorage.viceCamera
    })
    next(3, status)
  }

  const onselect = (label: string) => {
    setSelect((v) => {
      if (v.includes(label)) {
        return v
      } else {
        return [...v, label]
      }
    })
  }

  return (
    <Container {...stepAnimate} className="alls-testing">
      <div className="camera-list">
        <div className=" w-max flex">
          {devicesData.videoDevices.map((item, index) => (
            <div key={item.deviceId} className="camera-img" id={`camera-img${item.deviceId}`}>
              {/* <div className="text-sm text-white bg-black bg-opacity-30 absolute bottom-0 z-10 w-full text-center">
              {item.label}
            </div> */}
              <div
                onClick={() => onselect(item.label)}
                className={`w-[40px] h-[40px] rounded-full border-[2px] border-[#FFF] bg-[#d0cbd0] absolute z-10 top-[16px] right-[16px] text-[#FFF]
                flex items-center justify-center cursor-pointer
                ${select.length && select[0] === item.label ? 'bg-[#fc7b03]' : null}
                ${select.length > 1 && select[1] === item.label ? 'bg-[#4aadda]' : null}
                `}
              >
                {select.length && select[0] === item.label ? '主' : null}
                {select.length > 1 && select[1] === item.label ? '副' : null}
              </div>
            </div>
          ))}
        </div>
      </div>
      {devicesData.videoDevices.length > 0 && select.length === 0 ? (
        <div className="text-[#333] mt-[15px]">
          <div>请你选择主摄像头</div>
          <div>（拍摄人脸摄像头）</div>
        </div>
      ) : null}
      {devicesData.videoDevices.length > 1 && select.length === 1 ? (
        <div className="text-[#333] mt-[15px]">
          <div>请你选择副摄像头</div>
          <div>（拍摄画纸摄像头）</div>
        </div>
      ) : null}
      {isBtn && (select.length === 2 || select.length === devicesData.videoDevices.length) ? (
        <div className="btns">
          <div className="btn-ask anim_btn2" onClick={handleAsk}>
            ?
          </div>
          <div
            className="base-btn yes anim_btn2"
            onClick={() => {
              if (devicesData.videoDevices.length) {
                handleNext(true)
              } else {
                toast.error('未检测到摄像头，请选择看不到视频')
              }
            }}
          >
            能看到视频
          </div>
          <div className="base-btn no anim_btn2" onClick={() => handleNext(false)}>
            看不到视频
          </div>
        </div>
      ) : null}

      <AnimatePresence>
        {!isBtn ? (
          <motion.div {...fullAnimate} className="ask">
            <div>
              <div>如果你看不到视频画面，请按以下方式排查问题：</div>
              <div>1.请检查摄像头是否被遮挡</div>
              <div>2.台式机请检测是否有外接摄像头</div>
            </div>
            <div className="yes-ask anim_btn2" onClick={handleAsk}>
              知道了
            </div>
          </motion.div>
        ) : null}
      </AnimatePresence>
      <Modal show={noCameraTip} header="" cancelText="确定" cancel={() => setnoCameraTip(false)}>
        <div className="p-[20px] mb-[20px]">未检测到摄像头，请接入摄像头以保证学习效果哦！</div>
      </Modal>
    </Container>
  )
}

const Container = styled(motion.div)`
  display: flex;
  .camera-list {
    width: 100%;
    overflow: auto;
    padding-bottom: 10px;
    .camera-img {
      width: 260px;
      height: 200px;
      background: rgba(51, 51, 51, 1);
      border-radius: 9px;
      overflow: hidden;
      background-position: 0 0;
      background-size: 100% 100%;
      position: relative;
      margin: 0 10px;
    }
    .camera-check {
      cursor: pointer;
      display: inline-block;
      width: 20px;
      height: 20px;
      position: absolute;
      background-color: rgba(0, 0, 0, 0.1);
      box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.28);
      border: 1px solid #fff;
      border-radius: 50%;
      top: 5px;
      right: 5px;
      z-index: 1;
    }
    .cameraChecked {
      background-image: url('${cameraChose1Img}');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .btns {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    // justify-content: space-around;
    margin-top: 80px;
  }
  .ask {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    line-height: 20px;
    font-size: 14px;
    // width: 750px;
    height: 110px;
    background: rgba(255, 241, 229, 1);
    border-radius: 0px 0px 25px 25px;
    display: flex;
    justify-content: space-between;
    // align-items: flex-end;
    padding: 30px 25px;
    box-sizing: border-box;
    color: rgba(255, 120, 0, 1);
    // line-height: 16px;
    box-shadow: 0 4px 8px 4px #dcdcdc;
  }
  .yes-ask {
    text-decoration: underline;
  }
  .btn-ask {
    width: 45px;
    height: 45px;
    background: rgba(255, 120, 0, 0.1);
    border-radius: 28px;
    font-size: 25px;
    font-weight: 500;
    color: rgba(255, 120, 0, 1);
    text-align: center;
    line-height: 45px;
    position: absolute;
    left: -40px;
  }
  .btn {
    width: 213px;
    height: 42px;
    border-radius: 28px;
    color: #fff;
    text-align: center;
    line-height: 42px;
    font-size: 16px;
    font-weight: 500;
  }
  .yes {
    // background: linear-gradient(180deg, rgba(14, 198, 69, 1) 0%, rgba(16, 214, 75, 1) 100%);
    // box-shadow: 0px 3px 0px 0px rgba(13, 158, 56, 1);
    background: #0bc442;
    box-shadow: 0px 4px 0px 0px #0d9e38;
  }
  .no {
    // background: linear-gradient(180deg, rgba(243, 8, 8, 1) 0%, rgba(255, 65, 65, 1) 100%);
    // box-shadow: 0px 3px 0px 0px rgba(207, 11, 11, 1);
    background: #ff5050;
    box-shadow: 0px 3px 0px 0px #d1385f;
  }
`
